import React from 'react';
import PropTypes from 'prop-types';

import { strings } from './../../../localization';
import Switch from './../../../components/common/Switch';
import ProgressOverlay from './../../../components/common/ProgressOverlay';

import { UPDATE_SETTINGS_TIMEOUT } from './GlobalSettings';

export default class Gestures extends React.PureComponent {

    static propTypes = {
        gesturesAvailabilityPending: PropTypes.bool.isRequired,
        gesturesAvailabilityEnabled: PropTypes.bool,
        gesturesAvailabilitySettingLocked: PropTypes.bool,
        gesturesAvailabilitySettingLockedElement: PropTypes.element,
        gesturesAvailabilityErrorMessage: PropTypes.string,
        applyGesturesAvailability: PropTypes.func.isRequired,
        timeoutGesturesAvailability: PropTypes.func.isRequired,

        expandOrCollapseStateForUIReferences: PropTypes.func.isRequired,
        gesturesExpandReference: PropTypes.string.isRequired,
        gesturesExpandReferenceIsExpanded: PropTypes.bool.isRequired,
    }

    constructor(props) {

        super(props);

        this.applyGesturesAvailabilityTimeoutId = undefined;
    }

    componentWillUnmount() {
        console.log('Gestures componentWillUnmount');
        clearTimeout(this.applyGesturesAvailabilityTimeoutId);
    }

    expandOrCollapseSectionsAndSubsections = (isExpanded) => {
        this.props.expandOrCollapseStateForUIReferences(isExpanded,[
            this.props.gesturesExpandReference
        ]);
    }

    render() {
        console.log('Gestures render: ');
        console.log(this.props);
        return (
            <div id="component_document_id_gestures">
                <h3>
                    <button
                        className={this.props.gesturesExpandReferenceIsExpanded ? "settings-disclosure-wrapper" : "settings-disclosure-wrapper collapsed"}
                        onClick={() => {
                            this.expandOrCollapseSectionsAndSubsections(!this.props.gesturesExpandReferenceIsExpanded)}
                        }>
                        {strings.settings_global_gestures_header}
                        <i className="material-icons disclosure">keyboard_arrow_up</i>
                    </button>
                </h3>
                <div>{strings.settings_global_gestures_description}</div>
                <div className='setting-group-horiz'>
                    <div className='setting-group switch-group'>
                        <div>
                            <Switch
                                onChange={() => {

                                    clearTimeout(this.applyGesturesAvailabilityTimeoutId);
                                    const gesturesAvailabilityEnabled = this.props.gesturesAvailabilityEnabled;
                                    this.applyGesturesAvailabilityTimeoutId = setTimeout(() => {
                                        this.props.timeoutGesturesAvailability(gesturesAvailabilityEnabled)
                                    }, 
                                    UPDATE_SETTINGS_TIMEOUT);

                                    this.props.applyGesturesAvailability(!this.props.gesturesAvailabilityEnabled)
                                    .then(
                                        () => {clearTimeout(this.applyGesturesAvailabilityTimeoutId)},
                                        () => {clearTimeout(this.applyGesturesAvailabilityTimeoutId)}
                                    )
                                }}
                                checked={this.props.gesturesAvailabilityEnabled || false}
                                disabled={this.props.gesturesAvailabilityPending || this.props.gesturesAvailabilitySettingLocked}
                                smallFormat={true}
                            />
                            <label disabled={this.props.gesturesAvailabilityPending}>{this.props.gesturesAvailabilityEnabled?
                                strings.settings_feature_enabled
                            :
                                strings.settings_feature_disabled
                            }</label>
                            {this.props.gesturesAvailabilityPending ? <ProgressOverlay /> : null }
                            {this.props.gesturesAvailabilitySettingLocked ? <div className='disabled-overlay'></div> : null }
                        </div>
                        <div className="error-message">
                            {this.props.gesturesAvailabilityErrorMessage}
                        </div>
                        {this.props.gesturesAvailabilitySettingLockedElement}
                    </div>
                </div>
            </div>
        );
    }
}